<template>
  <div class="d-flex flex-column h-100 messages__container p-2">
    <h1 class="justify-content-center messages__title">
      {{ $i18n.t('Inbox') }}
    </h1>
    <div class="m-2 messages__filtered text-center">
      {{ $i18n.t('Filtered_by_last_10_unread_messages') }}
    </div>
    <div class="d-flex flex-column messages__received">
      <div class="messages__search">
        <div class="d-flex flex-row">
          <el-input
            :placeholder="$i18n.t('search_messages')"
            data-id="search_messages"
            v-model="search"
            @change="filterMessages($event, false)"
          >
          </el-input>
          <el-button
            data-id="search_messages_button"
            class="messages__search--button"
            icon="el-icon-search"
            @click="filterMessages($event, true)"
          >
          </el-button>
        </div>
      </div>
      <div v-if="messages.length" class="messages__wall">
        <el-card
          role="button"
          shadow="hover"
          class="m-2 b-0 messages__unread"
          v-for="message in messages"
          :key="message.idMessage"
        >
          <div
            :data-id="`message-${message.idMessage}`"
            class="d-flex flex-row"
            @click="handleMessageClick(message.idMessage)"
          >
            <span><img class="messages__avatar" :src="getImageSource(message)" alt="avatar" /></span>
            <div class="ms-3">
              <div class="messages__sender mb-2">
                {{ message.fullName || message.userName }}
              </div>
              <div class="mb-3 messages__subject">
                <span>{{ message.subject }}</span>
                <span v-if="message.attachment" class="material-icons messages__attachment">attach_file</span>
              </div>
              <div class="fw-light mb-2 messages__content" v-html="message.content"></div>
              <span class="fw-lighter messages__time">{{ elapsedTime(message.createDate) }}</span>
            </div>
          </div>
        </el-card>
      </div>
      <div v-else>
        <el-empty :description="$i18n.t('no_message_to_display')"></el-empty>
      </div>
      <div class="messages__buttons mt-auto">
        <el-button
          v-for="button in buttons"
          :data-id="button.label"
          :key="button.url"
          class="w-100 mb-1"
          is-plain
          @click="handleButton(button.url, button.name)"
        >
          {{ $i18n.t(button.label) }}
        </el-button>
      </div>
    </div>
    <modal></modal>
  </div>
</template>

<script>
import Modal from '../modal/Modal'

import { get } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'InternalMessages',
  components: {
    Modal,
  },
  data() {
    return {
      messages: [],
      search: '',
      buttons: [
        {
          url: '/message/index',
          label: 'all_messages',
          name: 'all',
        },
        {
          url: 'message/create',
          label: 'create_message',
          name: 'create',
        },
      ],
      avatar: get(this, '$CORE.avatarUrl', '/static/avatar.png'),
      updateUrlBase: '/message/index?ID_MESSAGE=',
      idSUser: get(this, '$CORE.params.ID_S_USER', null),
    }
  },
  methods: {
    ...mapActions('popup', ['setOpened', 'setUrl']),
    async getMessages() {
      return (
        await this.$client.execute({
          operationId: 'Message_getMessages',
          parameters: {
            id: this.idSUser,
          },
        })
      ).body
    },
    handleButton(link, name) {
      if (name === 'create') {
        this.setUrl(link)
        this.setOpened()
      } else {
        this.$router.push(link)
      }
    },
    handleMessageClick(id) {
      this.setMessageToRead(id)
      this.$router.push(`${this.updateUrlBase}${id}#empty`)
    },
    elapsedTime(datetime) {
      return moment(datetime).fromNow()
    },
    async getFilteredMessages(filterText) {
      return (
        await this.$client.execute({
          operationId: 'Message_filterMessages',
          parameters: {
            id: this.idSUser,
            filterText,
          },
        })
      ).body
    },
    async filterMessages(event, isButton) {
      let filterText = ''
      isButton ? (filterText = this.search) : (filterText = event)
      this.messages = await this.getFilteredMessages(filterText)
    },
    async setMessageToRead(id) {
      await this.$client.execute({
        operationId: 'Message_setMessageToRead',
        parameters: {
          id,
        },
      })
    },
    getImageSource(message) {
      const id = message.idDocumentProfilePic || message.idDocumentProfile
      return id ? `/download/${id}` : this.avatar
    },
  },
  async created() {
    this.messages = await this.getMessages()
    this.$emit('get-message-count')
  },
}
</script>

<style scoped lang="scss">
.messages__title {
  color: $light1;
}
.messages__filtered {
  color: $light1;
  font-size: x-small;
}
.messages__avatar {
  height: 35px;
  width: 35px;
  object-fit: cover;
  border-radius: 50%;
}
.messages__buttons {
  margin-top: auto;
  padding: 5px;
  padding-top: 10px;
}
.messages__content,
.messages__subject,
.messages__sender {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
  width: 170px;
}
.messages__subject,
.messages__sender {
  -webkit-line-clamp: 1;
}
.messages__content {
  -webkit-line-clamp: 3;
}
.messages__sender {
  font-weight: 600;
}
.messages__subject {
  font-size: smaller;
  font-weight: 500;
}
.messages__content {
  font-size: smaller;
}
.messages__time {
  font-size: x-small;
}
.messages__attachment {
  font-size: 12px;
  vertical-align: bottom;
}
.el-card {
  background-color: $border-color-lighter;
}
.messages__wall {
  overflow: scroll;
}
.messages__wall::-webkit-scrollbar {
  display: none;
}
.messages__search--button {
  width: 60px !important;
  border-radius: 0 8px 8px 0;
}
.messages__unread {
  border-right: 7px solid $danger-border-color;
}
.messages__received {
  height: calc(100% - 50px);
}
</style>

<style lang="scss">
.messages__container {
  .el-tabs__item {
    color: $white !important;
  }
  .el-card {
    border-radius: $border-radius;
  }
  .el-tabs__content {
    height: 100%;
  }
  .messages__search {
    background-color: $border-color-lighter;
    border-radius: $border-radius;
    margin: 8px;
    input {
      color: $default-font-color;
    }
    span {
      color: $default-font-color !important;
    }
  }
  .el-tabs__active-bar {
    background-color: $white;
  }
  .el-tabs__nav-wrap {
    &:after {
      background-color: $default-font-color !important;
    }
  }
}
</style>
